import { icons } from '@ublend-npm/aulaui-next';
import React from 'react';
import { Transforms } from 'slate';
import { ReactEditor, useReadOnly } from 'slate-react';
import { AulaPlugin } from '../plugins';
import { DragContainer, DragContent, DragHandle } from './dragHandle.styled';

export const dragHandle: AulaPlugin = (editableProps, editor, context) => ({
  ...editableProps,
  renderElement: (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isReadOnly = useReadOnly();

    if (editableProps.renderElement == null) {
      throw new Error('dragHandle plugin cannot be first renderElement method');
    }

    const { element } = props;

    const path = ReactEditor.findPath(editor, element);
    const content = editableProps.renderElement(props);

    if (path.length > 1 || isReadOnly) {
      return content;
    }

    return (
      <DragContainer>
        <DragHandle
          type={element?.type as string}
          data-block-button
          data-testid="drag-handle"
          aria-hidden
          contentEditable={false}
          onMouseDown={(e) => {
            e.stopPropagation();
            Transforms.select(editor, ReactEditor.findPath(editor, element));
            context?.setDraggingElement(element);
          }}
        >
          <icons.DragIndicatorIcon />
        </DragHandle>
        <DragContent>{content}</DragContent>
      </DragContainer>
    );
  },
});
